import _ from 'lodash';

const isTwoArraysEqual = (array1, array2) => _.isEqual(_.sortBy(array1), _.sortBy(array2));
export default isTwoArraysEqual;
